import { Product, SpendHolder } from '../types/types';

export const buildProductHierarchyTreeData = (
  products: Product[],
  withSpend = false,
) => {
  if (withSpend) {
    return (products || []).map((product) => {
      return {
        ...product,
        hierarchy: isBaseProduct(product.id, product?.baseProductId)
          ? [product.id]
          : hasSpendValueChildProduct(product.spend ?? null)
          ? [product?.baseProductId, product.id]
          : [],
      } as Product;
    });
  }
  return (products || []).map((product) => {
    return {
      ...product,
      hierarchy: isBaseProduct(product.id, product?.baseProductId)
        ? [product.id]
        : [product?.baseProductId, product.id],
    } as Product;
  });
};

const isBaseProduct = (productId: number, baseProductId?: number | null) => {
  return !!productId && baseProductId === null;
};

const hasSpendValueChildProduct = (productSpend: SpendHolder | null) => {
  return !!productSpend;
};

export const buildProductHierarchyTreeDataWithCustomMatchingFn = <T>(
  itemList: T[],
  customFn: (item: T) => number[],
) => {
  return (itemList || []).map((item) => {
    return {
      ...item,
      hierarchy: customFn(item),
    } as T;
  });
};
